import { CdkDragDrop, CdkDropList } from "@angular/cdk/drag-drop";
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ESigningOrderType, IActivityDto } from "core/dto";
import { Subject, combineLatest, distinctUntilChanged, map, startWith } from "rxjs";
import { IActivity } from "../../../../dto-map/i-activity";
import { ActivityCollectionService } from "../activity-collection.service";
import { ActivityItemGroupService } from "./activity-item-group.service";


@Component({
  selector: 'ss-activity-item-group',
  templateUrl: './activity-item-group.component.html',
  styleUrls: ['./activity-item-group.component.css'],
  providers: [
    ActivityItemGroupService
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityItemGroupComponent implements OnInit, OnDestroy {

  private readonly _destroy = new Subject<void>();

  private _groupIndex!: number
  @ViewChild('placeholder')
  private _placeholderRef!: ElementRef<HTMLElement>

  @ViewChild(CdkDropList)
  private _dropList!: CdkDropList

  @ViewChild('groupDiv')
  private _divRef!: ElementRef<HTMLDivElement>

  @Input() get groupIndex() {
    return this._groupIndex
  }

  set groupIndex(value: number) {
    this._groupIndex = value;
    this._activityItemGroupService.groupIndex = this.groupIndex;
  }

  private _activities!: IActivity[]
  @Input() get activities() {
    return this._activities
  }

  set activities(value: IActivity[]) {
    this._activities = value;
  }


  readonly placeHolderVisibleSubject = new Subject<boolean>();
  readonly dropSubject = this._activityCollectionService.dropSubject;
  readonly moveSubject = this._activityCollectionService.moveSubject;

  readonly activityDragComponentsObs = this._activityCollectionService.activityDragComponentsSubject
    .pipe(map(activityDragComponents => activityDragComponents.filter(comp => comp?.activity?.orderIndex === this.groupIndex)));

  readonly groupHasMultipleItemsObs = combineLatest([
    this._activityItemGroupService.groupHasMultipleItemsObs,
    this.moveSubject.pipe(
      map((move) => !move ? false : Boolean(this._dropList.element.nativeElement.querySelector('.cdk-drag-placeholder'))),
      startWith(false)
    ),
    this._activityCollectionService.processSigningOrderSubject
  ])
    .pipe(
      map(([groupHasMultipleItems, inPreview, processSigningOrder]) => processSigningOrder === ESigningOrderType.custom && (groupHasMultipleItems || inPreview)),
      distinctUntilChanged()
    )


  constructor(
    private readonly _activityItemGroupService: ActivityItemGroupService,
    private readonly _activityCollectionService: ActivityCollectionService,

  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
  }

  drop(evParams: CdkDragDrop<any>) {

    this.dropSubject.next(evParams)
  }

  trackActivityById(idx: number, activity: IActivityDto) {

    return 'activity-item-' + activity.id;

  }

  ngOnDestroy(): void {
    this._destroy.next();
  }

}
